import {Divider, IconButton, InputLabel, Stack, Typography} from '@mui/material';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import {Sizes} from '@constants/sizes.constants';
import React from 'react';
import {ManageIssue} from '@store/operations/issues';
import {useTranslation} from 'react-i18next';
import SelectFileCardComponent from '@components/inputs/selectFileCard/SelectFileCard.component';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Outlet, useNavigate} from 'react-router-dom';
import {filesService} from '@store/files';

interface IssueConnectFormProps {
  isCreation?: boolean;
  issue: ManageIssue;
  updateIssue: (data: ManageIssue) => void;
}

const IssueConnectForm = (props: IssueConnectFormProps) => {
  const {isCreation, issue, updateIssue} = props;

  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <>
      <Stack py="20px" spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontSize={16} fontWeight="700">
            {t('operations.nonCompliance.manage.connect')}
          </Typography>
          {issue.documents?.length &&
              <IconButton target="_blank" href={filesService.getDocumentUrl(issue.documents[0].id)}><OpenInNewIcon
                  color="primary"/></IconButton>}
        </Stack>
        <Stack spacing={2}>
          <Stack>
            <SelectFileCardComponent
              accept=".png, .svg, .jpg, .jpeg"
              document={issue.documents?.length ? issue.documents[0] : undefined}
              handleUpdateDocument={(d) => updateIssue({documents: d ? [d] : []})}/>
          </Stack>
          {!isCreation && issue.executionId && (
            <>
              <TextFieldComponent
                labelWidth={Sizes.drawerInputLabelWidth}
                label={t('operations.nonCompliance.manage.ticket')}
                value={issue.executionSignature}
                readOnly/>
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <InputLabel sx={{width: Sizes.drawerInputLabelWidth}} required={false}>
                  {t('operations.nonCompliance.manage.ticketDetails')}
                </InputLabel>
                <IconButton
                  onClick={() => navigate(`executions/${issue.executionId}`)}
                >
                  <OpenInNewIcon color="primary"/>
                </IconButton>
              </Stack>
            </>
          )}
          {!isCreation && (
            <>
              <>
                <TextFieldComponent
                  labelWidth={Sizes.drawerInputLabelWidth}
                  label={t('global.createByFullName')}
                  value={`${issue.author?.firstName} ${issue.author?.lastName}`}
                  readOnly/>
                <Stack direction="row" justifyContent="space-between" spacing={2}>
                  <InputLabel sx={{width: Sizes.drawerInputLabelWidth}} required={false}>
                    {t('operations.nonCompliance.manage.authorDetails')}
                  </InputLabel>
                  <IconButton
                    onClick={() => navigate(`settings/users/${issue.author?.id}`)}
                  >
                    <OpenInNewIcon color="primary"/>
                  </IconButton>
                </Stack>
              </>
            </>
          )}
        </Stack>
      </Stack>
      <Divider variant="fullWidth" orientation="horizontal"/>
      <Outlet/>
    </>
  );
};

export default IssueConnectForm;
